import { TAGS } from "../constants";
import {
  AddDosespotPatient,
  AddEPrescribeClinician,
  EPrescribePharmacy,
  EPrescribePriorAuth,
  PharmacyPatient,
} from "../types";
import { api } from "./api";

export const ePrescribeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    addClinician: builder.mutation<
      number,
      { employeeId: string; body: AddEPrescribeClinician }
    >({
      query: ({ employeeId, body }) => ({
        method: "POST",
        url: `/api/e-prescribe/add-clinician/${employeeId}`,
        body,
      }),
      invalidatesTags: [TAGS.PHARMACY_PROVIDERS],
    }),
    addPatient: builder.mutation<PharmacyPatient, AddDosespotPatient>({
      query: (body) => ({
        url: `/api/e-prescribe/add-patient`,
        body,
        method: "POST",
      }),
      invalidatesTags(_result, _error, arg) {
        return [
          {
            type: TAGS.DOSESPOT_PATIENT,
            id: arg.NonDoseSpotMedicalRecordNumber,
          },
        ];
      },
    }),
    getClinicianRegistrationStatus: builder.query<{ status: string }, number>({
      query: (externalClinicianId: number) => ({
        method: "GET",
        url: `/api/e-prescribe/${externalClinicianId}/registration-status`,
      }),

      providesTags: (_returns, _error, args) => [
        { type: TAGS.E_PRESCRIBE, id: args },
      ],
    }),
    getSsoUrl: builder.query<{ link: string }, { patientId?: number }>({
      query: ({ patientId }) => ({
        method: "GET",
        url: `/api/e-prescribe/sso`,
        params: { patientId: patientId ?? undefined },
      }),
    }),
    searchNearbyPharmacies: builder.query<
      EPrescribePharmacy[],
      { patientId: number; name?: string }
    >({
      query: ({ patientId, name }) => ({
        method: "GET",
        url: `/api/e-prescribe/pharmacies/search/patient/${patientId}`,
        params: {
          name: name ?? undefined,
        },
      }),
      providesTags: [TAGS.E_PRESCRIBE_PHARMACIES],
    }),
    getPriorAuthStatus: builder.query<EPrescribePriorAuth[], number>({
      query: (caseId) => ({
        method: "GET",
        url: `/api/e-prescribe/prior-auth/${caseId}`,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.E_PRESCRIBE_PRIOR_AUTHS, id: args },
      ],
    }),
  }),
});

export const {
  useAddClinicianMutation,
  useAddPatientMutation,
  useGetClinicianRegistrationStatusQuery,
  useGetSsoUrlQuery,
  useSearchNearbyPharmaciesQuery,
  useGetPriorAuthStatusQuery,
} = ePrescribeApi;
